import {parseJSON} from '../_helpers/fetch';

export type LambdaResponse = any;

export class Lambda {
    private static instance: Lambda;
    private baseUrl: string = 'https://lambda.eks-flow-dev.elis.abb.com/api/function/';

    private requestHeaders: any = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer NJ4gS3jWUpfVrkYB9bvHhM'
    };

    private constructor() {
    }

    public static getInstance(): Lambda {
        if (!Lambda.instance) {
            Lambda.instance = new Lambda();
        }

        return Lambda.instance;
    }

    public execute(functionName: string, data: object): Promise<LambdaResponse> {
        return this.fetch(functionName, data);
    }

    private fetch(endpoint: string, body: object): Promise<LambdaResponse> {
        console.log('fetching ' + this.baseUrl + endpoint);
        return fetch(this.baseUrl + endpoint, {
            headers: {
                ...this.requestHeaders,
            },
            method: 'POST',
            body: JSON.stringify(body)
        })
            .then(parseJSON);
    }
}